{
  "INBOX_MGMT": {
    "HEADER": "תיבות דואר נכנס",
    "DESCRIPTION": "ערוץ הוא אמצעי התקשורת שלקוח שלך בוחר כדי ליצור איתך אינטראקציה. תיבת דואר נכנס היא המקום שבו אתה מנהל אינטראקציות עבור ערוץ ספציפי. היא יכולה לכלול תקשורת ממקורות שונים כגון דוא\"ל, צ'אט חי ומדיה חברתית.",
    "LEARN_MORE": "למד עוד על תיבות דואר נכנס",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "תיבת הדואר הנכנס שלך מנותקת. לא תקבל הודעות חדשות עד שתאשר אותה מחדש.",
    "CLICK_TO_RECONNECT": "לחץ כאן כדי להתחבר מחדש.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "השלם הרשמה",
    "LIST": {
      "404": "אין תיבות דואר נכנס מצורפות לחשבון זה."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "בחר ערוץ",
        "BODY": "בחר את הספק שברצונך לשלב עם Chatwoot."
      },
      "INBOX": {
        "TITLE": "צור תיבת דואר נכנס",
        "BODY": "אמת את חשבונך וצור תיבת דואר נכנס."
      },
      "AGENT": {
        "TITLE": "הוסף נציג",
        "BODY": "הוסף נציגים לתיבת הדואר הנכנס שנוצרה."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "אתם מוכנים לצאת לדרך!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "שם תיבת הדואר הנכנס",
        "PLACEHOLDER": "הזן את שם תיבת הדואר הנכנס שלך (למשל: Acme Inc)",
        "ERROR": "נא הכנס שם תקני לתיבת הדואר"
      },
      "WEBSITE_NAME": {
        "LABEL": "שם האתר",
        "PLACEHOLDER": "הזן את שם האתר שלך (למשל: Acme Inc)"
      },
      "FB": {
        "HELP": "נ. ב: על ידי כניסה, אנו מקבלים גישה רק להודעות של הדף שלך. לעולם לא ניתן לגשת להודעות הפרטיות שלך על ידי Chatwoot.",
        "CHOOSE_PAGE": "בחר עמוד",
        "CHOOSE_PLACEHOLDER": "בחר עמוד מהרשימה",
        "INBOX_NAME": "שם תיבת הדואר הנכנס",
        "ADD_NAME": "הוסף שם לתיבת הדואר הנכנס שלך",
        "PICK_NAME": "בחר שם לתיבת הדואר הנכנס שלך",
        "PICK_A_VALUE": "בחר ערך",
        "CREATE_INBOX": "צור תיבת דואר נכנס"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "המשך עם אינסטגרם",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "חבר את פרופיל האינסטגרם שלך",
        "HELP": "כדי להוסיף את פרופיל האינסטגרם שלך כערוץ, עליך לאמת את פרופיל האינסטגרם שלך על ידי לחיצה על 'המשך עם אינסטגרם' ",
        "ERROR_MESSAGE": "אירעה שגיאה בחיבור לאינסטגרם, אנא נסה שוב",
        "ERROR_AUTH": "אירעה שגיאה בחיבור לאינסטגרם, אנא נסה שוב",
        "NEW_INBOX_SUGGESTION": "חשבון אינסטגרם זה היה מקושר בעבר לתיבת דואר נכנס אחרת והועבר כעת לכאן. כל ההודעות החדשות יופיעו כאן. תיבת הדואר הנכנס הישנה לא תוכל יותר לשלוח או לקבל הודעות עבור חשבון זה.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "כדי להוסיף את פרופיל הטוויטר שלך כערוץ, עליך לאמת את פרופיל הטוויטר שלך על ידי לחיצה על 'היכנס באמצעות טוויטר' ",
        "ERROR_MESSAGE": "אירעה שגיאה בחיבור לטוויטר, אנא נסה שוב",
        "TWEETS": {
          "ENABLE": "צור שיחות מהציוצים המוזכרים"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "ערוץ האתר",
        "DESC": "צור ערוץ לאתר שלך והתחל לתמוך בלקוחות שלך באמצעות ווידג'ט האתר שלנו.",
        "LOADING_MESSAGE": "יצירת ערוץ תמיכה באתר",
        "CHANNEL_AVATAR": {
          "LABEL": "אוואטר הערוץ"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "כתובת אתר של Webhook",
          "PLACEHOLDER": "אנא הזן את כתובת ה-Webhook URL שלך",
          "ERROR": "אנא הכנס כתובת URL חוקית"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "דומיין אתר",
          "PLACEHOLDER": "הזן את שם האתר שלך (למשל: Acme Inc)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "כותרת ברוכים הבאים",
          "PLACEHOLDER": "שלום שם !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "ברוך הבא לתיוג",
          "PLACEHOLDER": "אנחנו עושים את זה פשוט להתחבר אלינו. שאל אותנו כל דבר, או שתף את המשוב שלך."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "הודעת ברכה בערוץ",
          "PLACEHOLDER": "Acme Inc עונה בדרך כלל תוך מספר שעות."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "אפשר ברכה בערוץ",
          "HELP_TEXT": "שלח הודעת פתיחה אוטומטית ביצירת שיחה חדשה.",
          "ENABLED": "מופעל",
          "DISABLED": "כבוי"
        },
        "REPLY_TIME": {
          "TITLE": "הגדר זמן תגובה",
          "IN_A_FEW_MINUTES": "בעוד כמה דקות",
          "IN_A_FEW_HOURS": "בעוד כמה שעות",
          "IN_A_DAY": "ביום",
          "HELP_TEXT": "זמן תשובה זה יוצג בווידג'ט הצ'אט החי"
        },
        "WIDGET_COLOR": {
          "LABEL": "צבע יישומון",
          "PLACEHOLDER": "עדכן את צבע הווידג'ט המשמש בווידג'ט"
        },
        "SUBMIT_BUTTON": "צור תיבת דואר נכנס",
        "API": {
          "ERROR_MESSAGE": "יצירת ערוץ אתר אינטרנט נכשלה, אנא נסה שנית"
        }
      },
      "TWILIO": {
        "TITLE": "ערוץ SMS/ווטסאפ של Twilio",
        "DESC": "שלב את Twilio והתחל לתמוך בלקוחות שלך באמצעות SMS או WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "חשבון SID",
          "PLACEHOLDER": "אנא הזן את SID חשבון Twilio שלך",
          "ERROR": "שדה חובה"
        },
        "API_KEY": {
          "USE_API_KEY": "השתמש באימות מפתח API",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "אנא הזן את ה-API Key SID שלך",
          "ERROR": "שדה חובה"
        },
        "API_KEY_SECRET": {
          "LABEL": "סוד מפתח API",
          "PLACEHOLDER": "אנא הזן את סוד מפתח ה-API שלך",
          "ERROR": "שדה חובה"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "ערוץ הודעות SID",
          "PLACEHOLDER": "נא הכנס מזהה Twilio Messaging Service SID",
          "ERROR": "שדה חובה",
          "USE_MESSAGING_SERVICE": "השתמש ב- Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "סוג ערוץ",
          "ERROR": "אנא בחר את סוג הערוץ שלך"
        },
        "AUTH_TOKEN": {
          "LABEL": "אסימון אימות",
          "PLACEHOLDER": "אנא הזן את ה-Twilio Auth Token שלך",
          "ERROR": "שדה חובה"
        },
        "CHANNEL_NAME": {
          "LABEL": "שם תיבת הדואר הנכנס",
          "PLACEHOLDER": "נא להזין שם תיבת דואר נכנס",
          "ERROR": "שדה חובה"
        },
        "PHONE_NUMBER": {
          "LABEL": "מספר טלפון",
          "PLACEHOLDER": "נא להזין את מספר הטלפון שממנו תישלח ההודעה.",
          "ERROR": "נא ספק מספר טלפון תקני שמתחיל ב- '+' ולא מכיל רווחים."
        },
        "API_CALLBACK": {
          "TITLE": "כתובת אתר להתקשרות חוזרת",
          "SUBTITLE": "עליך להגדיר את כתובת האתר להתקשרות חוזרת של ההודעה ב-Twilio עם כתובת האתר המוזכרת כאן."
        },
        "SUBMIT_BUTTON": "צור ערוץ Twilio",
        "API": {
          "ERROR_MESSAGE": "לא הצלחנו לאמת את האישורים של Twilio, אנא נסה שוב"
        }
      },
      "SMS": {
        "TITLE": "ערוץ SMS",
        "DESC": "התחל לתמוך בלקוחותיך באמצעות SMS.",
        "PROVIDERS": {
          "LABEL": "ספק API",
          "TWILIO": "טוויליו",
          "BANDWIDTH": "Bandwidth"
        },
        "API": {
          "ERROR_MESSAGE": "שמירת ערוץ ה-SMS נכשלה"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "מזהה חשבון",
            "PLACEHOLDER": "נא הכנס את מזהה ה- Bandwidth Account ID שלך",
            "ERROR": "שדה חובה"
          },
          "API_KEY": {
            "LABEL": "מפתח API",
            "PLACEHOLDER": "אנא הזן את מפתח ה-API של Bandwidth",
            "ERROR": "שדה חובה"
          },
          "API_SECRET": {
            "LABEL": "סוד API",
            "PLACEHOLDER": "אנא הזן את סוד ה-API של Bandwidth",
            "ERROR": "שדה חובה"
          },
          "APPLICATION_ID": {
            "LABEL": "מזהה אפליקציה",
            "PLACEHOLDER": "נא הכנס את מזהה ה-Bandwidth Application ID שלך",
            "ERROR": "שדה חובה"
          },
          "INBOX_NAME": {
            "LABEL": "שם תיבת הדואר הנכנס",
            "PLACEHOLDER": "נא להזין שם תיבת דואר נכנס",
            "ERROR": "שדה חובה"
          },
          "PHONE_NUMBER": {
            "LABEL": "מספר טלפון",
            "PLACEHOLDER": "נא להזין את מספר הטלפון שממנו תישלח ההודעה.",
            "ERROR": "נא ספק מספר טלפון תקני שמתחיל ב- '+' ולא מכיל רווחים."
          },
          "SUBMIT_BUTTON": "צור ערוץ Bandwidth",
          "API": {
            "ERROR_MESSAGE": "לא הצלחנו לאמת את פרטי חשבון ה-Bandwidth שלך, אנא נסה שנית"
          },
          "API_CALLBACK": {
            "TITLE": "כתובת אתר להתקשרות חוזרת",
            "SUBTITLE": "עליך להגדיר את ה- message callback URL ב- Bandwidth עם ה-URL שמוצג כאן."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "ערוץ וואטסאפ",
        "DESC": "התחל לתמוך בלקוחות שלך באמצעות וואטסאפ.",
        "PROVIDERS": {
          "LABEL": "ספק API",
          "WHATSAPP_EMBEDDED": "WhatsApp עסקי",
          "TWILIO": "טוויליו",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "הגדרה מהירה דרך Meta",
          "TWILIO_DESC": "התחבר באמצעות פרטי זיהוי של Twilio",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "בחר את ספק ה-API שלך",
          "DESCRIPTION": "בחר את ספק ה-WhatsApp שלך. תוכל להתחבר ישירות דרך Meta שאינה דורשת הגדרה, או להתחבר דרך Twilio באמצעות פרטי החשבון שלך."
        },
        "INBOX_NAME": {
          "LABEL": "שם תיבת הדואר הנכנס",
          "PLACEHOLDER": "נא להזין שם תיבת דואר נכנס",
          "ERROR": "שדה חובה"
        },
        "PHONE_NUMBER": {
          "LABEL": "מספר טלפון",
          "PLACEHOLDER": "נא להזין את מספר הטלפון שממנו תישלח ההודעה.",
          "ERROR": "נא ספק מספר טלפון תקני שמתחיל ב- '+' ולא מכיל רווחים."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "מזהה מספר טלפון",
          "PLACEHOLDER": "נא הכנס את Phone number ID מתוך ממשק ה- Facebook developer.",
          "ERROR": "אנא הכנס ערך תקין."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "מזהה חשבון עסקי",
          "PLACEHOLDER": "נא הכנס את Business Account ID מתוך ממשק ה- Facebook developer.",
          "ERROR": "אנא הכנס ערך תקין."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "אסימון אימות Webhook",
          "PLACEHOLDER": "הזן אסימון אימות שברצונך להגדיר עבור Webhooks של Facebook.",
          "ERROR": "אנא הכנס ערך תקין."
        },
        "API_KEY": {
          "LABEL": "מפתח API",
          "SUBTITLE": "הגדר את מפתח ה-API של וואטסאפ.",
          "PLACEHOLDER": "מפתח API",
          "ERROR": "אנא הכנס ערך תקין."
        },
        "API_CALLBACK": {
          "TITLE": "כתובת אתר להתקשרות חוזרת",
          "SUBTITLE": "עליך להגדיר את ה- webhook URL ואת ה- verification token הבאים בממשק ה- Facebook Developer.",
          "WEBHOOK_URL": "כתובת אתר של Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "אסימון אימות Webhook"
        },
        "SUBMIT_BUTTON": "צור ערוץ וואטסאפ",
        "EMBEDDED_SIGNUP": {
          "TITLE": "הגדרה מהירה עם Meta",
          "DESC": "השתמש בזרימת ההרשמה המשובצת של WhatsApp כדי לחבר במהירות מספרים חדשים. תועבר ל-Meta כדי להיכנס לחשבון WhatsApp העסקי שלך. גישת מנהל מערכת תעזור להפוך את ההגדרה לחלקה וקלה.",
          "BENEFITS": {
            "TITLE": "יתרונות ההרשמה המשובצת:",
            "EASY_SETUP": "אין צורך בהגדרה ידנית",
            "SECURE_AUTH": "אימות מאובטח מבוסס OAuth",
            "AUTO_CONFIG": "הגדרת Webhook ומספר טלפון אוטומטית"
          },
          "LEARN_MORE": {
            "TEXT": "כדי ללמוד עוד על ההרשמה המשולבת, התמחור והמגבלות, בקר ב- {link}.",
            "LINK_TEXT": "קישור זה"
          },
          "SUBMIT_BUTTON": "התחבר עם WhatsApp עסקי",
          "AUTH_PROCESSING": "מאמת עם Meta",
          "WAITING_FOR_BUSINESS_INFO": "אנא השלם את הגדרת העסק בחלון Meta...",
          "PROCESSING": "מגדיר את חשבון WhatsApp העסקי שלך",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "טוען SDK של Facebook...",
          "CANCELLED": "הרשמת WhatsApp בוטלה",
          "SUCCESS_TITLE": "חשבון WhatsApp עסקי מחובר!",
          "WAITING_FOR_AUTH": "ממתין לאימות...",
          "INVALID_BUSINESS_DATA": "התקבלו נתוני עסק לא חוקיים מ-Facebook. אנא נסה שוב.",
          "SIGNUP_ERROR": "אירעה שגיאת הרשמה",
          "AUTH_NOT_COMPLETED": "האימות לא הושלם. אנא הפעל מחדש את התהליך.",
          "SUCCESS_FALLBACK": "חשבון WhatsApp עסקי הוגדר בהצלחה",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "זרימת הגדרה ידנית",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "לא הצלחנו לשמור את ערוץ הוואטסאפ"
        }
      },
      "VOICE": {
        "TITLE": "ערוץ קולי",
        "DESC": "שלב את Twilio Voice והתחל לתמוך בלקוחות שלך באמצעות שיחות טלפון.",
        "PHONE_NUMBER": {
          "LABEL": "מספר טלפון",
          "PLACEHOLDER": "הזן את מספר הטלפון שלך (לדוגמה: +1234567890)",
          "ERROR": "אנא ספק מספר טלפון חוקי בפורמט E.164 (לדוגמה: +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "חשבון SID",
            "PLACEHOLDER": "הזן את Twilio Account SID שלך",
            "REQUIRED": "Account SID נדרש"
          },
          "AUTH_TOKEN": {
            "LABEL": "אסימון אימות",
            "PLACEHOLDER": "הזן את Twilio Auth Token שלך",
            "REQUIRED": "אסימון אימות נדרש"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "הזן את Twilio API Key SID שלך",
            "REQUIRED": "API Key SID נדרש"
          },
          "API_KEY_SECRET": {
            "LABEL": "סוד מפתח API",
            "PLACEHOLDER": "הזן את Twilio API Key Secret שלך",
            "REQUIRED": "סוד מפתח API נדרש"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "הגדר כתובת URL זו כ-Voice URL במספר הטלפון ובאפליקציית TwiML שלך ב-Twilio.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "הגדר כתובת URL זו כ-Status Callback URL במספר הטלפון שלך ב-Twilio."
        },
        "SUBMIT_BUTTON": "צור ערוץ קולי",
        "API": {
          "ERROR_MESSAGE": "לא הצלחנו ליצור את הערוץ הקולי"
        }
      },
      "API_CHANNEL": {
        "TITLE": "ערוץ API",
        "DESC": "שלב עם ערוץ API והתחל לתמוך בלקוחות שלך.",
        "CHANNEL_NAME": {
          "LABEL": "שם הערוץ",
          "PLACEHOLDER": "נא להזין שם ערוץ",
          "ERROR": "שדה חובה"
        },
        "WEBHOOK_URL": {
          "LABEL": "כתובת אתר של Webhook",
          "SUBTITLE": "הגדר את כתובת ה-URL שבה תרצה לקבל קריאות חוזרות על אירועים.",
          "PLACEHOLDER": "כתובת אתר של Webhook"
        },
        "SUBMIT_BUTTON": "צור ערוץ API",
        "API": {
          "ERROR_MESSAGE": "לא הצלחנו לשמור את ערוץ ה API"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "ערוץ דוא\"ל",
        "DESC": "שלב את תיבת הדואר הנכנס שלך.",
        "CHANNEL_NAME": {
          "LABEL": "שם הערוץ",
          "PLACEHOLDER": "נא להזין שם ערוץ",
          "ERROR": "שדה חובה"
        },
        "EMAIL": {
          "LABEL": "אימייל",
          "SUBTITLE": "אימייל לאן הלקוחות שלך שולחים לך כרטיסי תמיכה",
          "PLACEHOLDER": "אימייל"
        },
        "SUBMIT_BUTTON": "צור ערוץ דוא\"ל",
        "API": {
          "ERROR_MESSAGE": "לא הצלחנו לשמור את ערוץ האימייל"
        },
        "FINISH_MESSAGE": "התחל להעביר את המיילים שלך לכתובת הדוא\"ל הבאה.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "לחץ כאן",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "ערוץ LINE",
        "DESC": "השתלב עם ערוץ LINE והתחיל לתמוך בלקוחות שלך.",
        "CHANNEL_NAME": {
          "LABEL": "שם הערוץ",
          "PLACEHOLDER": "נא להזין שם ערוץ",
          "ERROR": "שדה חובה"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "מזהה ערוץ LINE",
          "PLACEHOLDER": "מזהה ערוץ LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "סוד ערוץ LINE",
          "PLACEHOLDER": "סוד ערוץ LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE ערוץ טוקן",
          "PLACEHOLDER": "LINE ערוץ טוקן"
        },
        "SUBMIT_BUTTON": "צור ערוץ LINE",
        "API": {
          "ERROR_MESSAGE": "לא הצלחנו לשמור את ערוץ LINE"
        },
        "API_CALLBACK": {
          "TITLE": "כתובת אתר להתקשרות חוזרת",
          "SUBTITLE": "עליך להגדיר את כתובת האתר של ה-webhook ביישום LINE עם כתובת האתר המוזכרת כאן."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "ערוץ טלגרם",
        "DESC": "השתלב עם ערוץ טלגרם והתחיל לתמוך בלקוחות שלך.",
        "BOT_TOKEN": {
          "LABEL": "אסימון בוט",
          "SUBTITLE": "הגדר את אסימון הבוט שקיבלת מ- Telegram BotFather.",
          "PLACEHOLDER": "אסימון בוט"
        },
        "SUBMIT_BUTTON": "צור ערוץ טלגרם",
        "API": {
          "ERROR_MESSAGE": "לא הצלחנו לשמור את ערוץ הטלגרם"
        }
      },
      "AUTH": {
        "TITLE": "בחר ערוץ",
        "DESC": "אנו תומכים בווידג'ט של צ'אט חי, עמוד פייסבוק, פרופיל טוויטר, WhatsApp, דוא\"ל וכו', כערוצי תקשורת. אם אתה רוצה לבנות ערוץ מותאם אישית, אתה יכול ליצור אותו באמצעות ערוץ ה-API. בחר ערוץ אחד מהאפשרויות מטה כדי להמשיך.",
        "TITLE_NEXT": "השלם את ההגדרה",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "אתר אינטרנט",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "פייסבוק",
            "DESCRIPTION": "חבר את דף הפייסבוק שלך"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "תמוך בלקוחות שלך ב-WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "אימייל",
            "DESCRIPTION": "התחבר עם Gmail, Outlook או ספקים אחרים"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "שלב ערוץ SMS עם Twilio או bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "צור ערוץ מותאם אישית באמצעות ה-API שלנו"
          },
          "TELEGRAM": {
            "TITLE": "טלגרם",
            "DESCRIPTION": "הגדר ערוץ טלגרם באמצעות אסימון בוט"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "שלב את ערוץ Line שלך"
          },
          "INSTAGRAM": {
            "TITLE": "אינסטגרם",
            "DESCRIPTION": "חבר את חשבון האינסטגרם שלך"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "קול",
            "DESCRIPTION": "שלב עם Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "סוכנים",
        "DESC": "כאן תוכל להוסיף סוכנים לניהול תיבת הדואר הנכנס החדשה שלך. רק לסוכנים שנבחרו אלה תהיה גישה לתיבת הדואר הנכנס שלך. סוכנים שאינם חלק מתיבת הדואר הנכנס הזו לא יוכלו לראות או להגיב להודעות בתיבת הדואר הנכנס הזו כאשר הם נכנסים. <br> <b>נ. ב.:</b> כמנהל מערכת, אם אתה זקוק לגישה לכל תיבות הדואר הנכנס, עליך להוסיף את עצמך כסוכן לכל תיבות הדואר הנכנס שאתה יוצר.",
        "VALIDATION_ERROR": "הוסף לפחות סוכן אחד לתיבת הדואר הנכנס החדשה שלך",
        "PICK_AGENTS": "בחר סוכנים לתיבת הדואר הנכנס"
      },
      "DETAILS": {
        "TITLE": "פרטי תיבת דואר נכנס",
        "DESC": "מהתפריט הנפתח למטה, בחר את דף הפייסבוק שברצונך להתחבר ל-Chatwoot. אתה יכול גם לתת שם מותאם אישית לתיבת הדואר הנכנס שלך לזיהוי טוב יותר."
      },
      "FINISH": {
        "TITLE": "הצלחתי!",
        "DESC": "סיימת בהצלחה לשלב את דף הפייסבוק שלך עם Chatwoot. בפעם הבאה שלקוח ישלח הודעה לדף שלך, השיחה תופיע אוטומטית בתיבת הדואר הנכנס שלך.<br>אנחנו גם מספקים לך סקריפט ווידג'ט שתוכל להוסיף בקלות לאתר שלך. ברגע שזה פעיל באתר שלך, לקוחות יכולים לשלוח לך הודעות ישירות מהאתר שלך ללא עזרה של כל כלי חיצוני והשיחה תופיע ממש כאן, ב-Chatwoot.<br>מגניב, הא? ובכן, אנחנו בטוח מנסים להיות :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "בחר את ספק הדוא\"ל שלך",
        "DESCRIPTION": "בחר את ספק הדוא\"ל שלך מהרשימה מטה. אם אתה לא מוצא את ספק הדוא\"ל שלך ברשימה, תוכל לבחור את אפשרות \"ספק אחר\" ולספק את הגדרות ה- IMAP ו-SMTP."
      },
      "MICROSOFT": {
        "TITLE": "אימייל של מיקרוסופט",
        "DESCRIPTION": "לחץ על Sign in with Microsoft בכדי להתחיל. אתה תופנה למסך ההתחברות של Microsoft. ברגע שתאשר את בקשת ההרשאות, תופנה חזרה להגדרות תיבת הדואר.",
        "EMAIL_PLACEHOLDER": "הכנס כתובת דוא\"ל",
        "SIGN_IN": "היכנס עם Microsoft",
        "ERROR_MESSAGE": "אירעה שגיאה בהתחברות ל- Microsoft, אנא נסה שנית"
      },
      "GOOGLE": {
        "TITLE": "דוא\"ל Google",
        "DESCRIPTION": "לחץ על כפתור 'היכנס עם Google' כדי להתחיל. תועבר לדף הכניסה לדוא\"ל. לאחר שתקבל את ההרשאות המבוקשות, תועבר בחזרה לשלב יצירת תיבת הדואר הנכנס.",
        "SIGN_IN": "היכנס עם Google",
        "EMAIL_PLACEHOLDER": "הכנס כתובת דוא\"ל",
        "ERROR_MESSAGE": "אירעה שגיאה בחיבור ל-Google, אנא נסה שוב"
      }
    },
    "DETAILS": {
      "LOADING_FB": "מאמת אותך עם פייסבוק...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "משהו השתבש, אנא רענן את הדף...",
      "ERROR_FB_UNAUTHORIZED": "אינך מורשה לבצע פעולה זו. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "יוצר את תיבת הדואר הנכנס שלך...",
      "TITLE": "הגדר את פרטי תיבת הדואר הנכנס",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "הוסף נציגים",
      "ADD_AGENTS": "מוסיף נציגים לתיבת הדואר הנכנס שלך..."
    },
    "FINISH": {
      "TITLE": "תיבת הדואר הנכנס שלך מוכנה!",
      "MESSAGE": "כעת תוכל ליצור קשר עם הלקוחות שלך דרך הערוץ החדש שלך. תמיכה שמחה",
      "BUTTON_TEXT": "קח אותי לשם",
      "MORE_SETTINGS": "הגדרות נוספות",
      "WEBSITE_SUCCESS": "סיימת בהצלחה ליצור ערוץ אתר אינטרנט. העתק את הקוד המוצג למטה והדבק אותו באתר שלך. בפעם הבאה שלקוח ישתמש בצ'אט החי, השיחה תופיע אוטומטית בתיבת הדואר הנכנס שלך.",
      "WHATSAPP_QR_INSTRUCTION": "סרוק את קוד ה-QR שלמעלה כדי לבדוק במהירות את תיבת הדואר הנכנס שלך ב-WhatsApp",
      "MESSENGER_QR_INSTRUCTION": "סרוק את קוד ה-QR שלמעלה כדי לבדוק במהירות את תיבת הדואר הנכנס שלך ב-Facebook Messenger",
      "TELEGRAM_QR_INSTRUCTION": "סרוק את קוד ה-QR שלמעלה כדי לבדוק במהירות את תיבת הדואר הנכנס שלך בטלגרם"
    },
    "REAUTH": "הרשאה מחדש",
    "VIEW": "צפה",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "הגדרות תיבת הדואר הנכנס עודכנו בהצלחה",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "ההקצאה האוטומטית עודכנה בהצלחה",
        "ERROR_MESSAGE": "לא הצלחנו לעדכן את הגדרות תיבת הדואר שלך, אנא נסה שנית מאוחר יותר."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "מופעל",
        "DISABLED": "כבוי"
      },
      "ENABLE_CSAT": {
        "ENABLED": "מופעל",
        "DISABLED": "כבוי"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "שם שולח",
        "SUB_TEXT": "בחר את השם המוצג ללקוח שלך כאשר הוא מקבל הודעות דוא\"ל מהסוכנים שלך.",
        "FOR_EG": "לדוגמה:",
        "FRIENDLY": {
          "TITLE": "ידידותי",
          "FROM": "מ",
          "SUBTITLE": "הוסף את שם הסוכן ששלח את התשובה בשם השולח כדי להפוך אותו לידידותי."
        },
        "PROFESSIONAL": {
          "TITLE": "מקצועי",
          "SUBTITLE": "השתמש רק בשם העסק שהוגדר כשם השולח בכותרת הדוא\"ל."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "הגדר את שם העסק שלך",
          "PLACEHOLDER": "הזן את שם העסק שלך",
          "SAVE_BUTTON_TEXT": "שמור"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "מופעל",
        "DISABLED": "כבוי"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "מופעל",
        "DISABLED": "כבוי"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "אפשר"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "מחק",
      "AVATAR_DELETE_BUTTON_TEXT": "מחק אווטר",
      "CONFIRM": {
        "TITLE": "אשר מחיקה",
        "MESSAGE": "האם אתה בטוח שברצונך למחוק ",
        "PLACE_HOLDER": "אנא הקלד {inboxName} כדי לאשר",
        "YES": "כן, מחק ",
        "NO": "לא, השאר "
      },
      "API": {
        "SUCCESS_MESSAGE": "תיבת הדואר הנכנס נמחקה בהצלחה",
        "ERROR_MESSAGE": "לא ניתן למחוק את תיבת הדואר הנכנס. בבקשה נסה שוב מאוחר יותר.",
        "AVATAR_SUCCESS_MESSAGE": "אווטר תיבת הדואר הנכנס נמחקה בהצלחה",
        "AVATAR_ERROR_MESSAGE": "לא ניתן למחוק את האווטר של תיבת הדואר הנכנס. בבקשה נסה שוב מאוחר יותר."
      }
    },
    "TABS": {
      "SETTINGS": "הגדרות",
      "COLLABORATORS": "משתפי פעולה",
      "CONFIGURATION": "תצורה",
      "CAMPAIGN": "קמפיין",
      "PRE_CHAT_FORM": "טופס צ'אט מקדים",
      "BUSINESS_HOURS": "שעות פעילות",
      "WIDGET_BUILDER": "בונה יישומונים",
      "BOT_CONFIGURATION": "הגדרות בוט",
      "ACCOUNT_HEALTH": "תקינות חשבון",
      "CSAT": "CSAT",
      "VOICE": "קול",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "נהל את חשבון WhatsApp שלך",
      "DESCRIPTION": "סקור את מצב חשבון WhatsApp שלך, מגבלות הודעות ואיכות. עדכן הגדרות או פתור בעיות במידת הצורך",
      "GO_TO_SETTINGS": "עבור למנהל העסקי של Meta",
      "NO_DATA": "נתוני תקינות אינם זמינים",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "מספר טלפון לתצוגה",
          "TOOLTIP": "מספר טלפון המוצג ללקוחות"
        },
        "VERIFIED_NAME": {
          "LABEL": "שם העסק",
          "TOOLTIP": "שם העסק שאומת על ידי WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "סטטוס שם לתצוגה",
          "TOOLTIP": "סטטוס אימות שם העסק שלך"
        },
        "QUALITY_RATING": {
          "LABEL": "דירוג איכות",
          "TOOLTIP": "דירוג איכות WhatsApp עבור חשבונך"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "דרגת מגבלת הודעות",
          "TOOLTIP": "מגבלת הודעות יומית עבור חשבונך"
        },
        "ACCOUNT_MODE": {
          "LABEL": "מצב חשבון",
          "TOOLTIP": "מצב הפעולה הנוכחי של חשבון WhatsApp שלך"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 לקוחות ל-24 שעות",
          "TIER_1000": "1K לקוחות ל-24 שעות",
          "TIER_1K": "1K לקוחות ל-24 שעות",
          "TIER_10K": "10K לקוחות ל-24 שעות",
          "TIER_100K": "100K לקוחות ל-24 שעות",
          "TIER_UNLIMITED": "לקוחות ללא הגבלה ל-24 שעות",
          "UNKNOWN": "דירוג אינו זמין"
        },
        "STATUSES": {
          "APPROVED": "אושר",
          "PENDING_REVIEW": "ממתין לבדיקה",
          "AVAILABLE_WITHOUT_REVIEW": "זמין ללא בדיקה",
          "REJECTED": "נדחה",
          "DECLINED": "סורב",
          "NON_EXISTS": "לא קיים"
        },
        "MODES": {
          "SANDBOX": "ארגז חול (Sandbox)",
          "LIVE": "לחיות"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "הגדרות",
    "FEATURES": {
      "LABEL": "מאפיינים",
      "DISPLAY_FILE_PICKER": "הצג את בוחר הקבצים בווידג'ט",
      "DISPLAY_EMOJI_PICKER": "הצג את בוחר האמוג'י בווידג'ט",
      "ALLOW_END_CONVERSATION": "אפשר למשתמשים לסיים שיחות באמצעות ה- Widget",
      "USE_INBOX_AVATAR_FOR_BOT": "השתמש בשם ובדמות תיבת הדואר הנכנס עבור הבוט"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "סקריפט מסנג'ר",
      "MESSENGER_SUB_HEAD": "מקם את הכפתור הזה בתוך תג הגוף שלך",
      "ALLOWED_DOMAINS": {
        "TITLE": "דומיינים מורשים",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "מפתח סודי",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "סוכנים",
      "INBOX_AGENTS_SUB_TEXT": "הוסף או הסר נציגים מתיבת הדואר הנכנס הזו",
      "AGENT_ASSIGNMENT": "שיוך שיחה",
      "AGENT_ASSIGNMENT_SUB_TEXT": "עדכן הגדרות שיוך שיחה",
      "UPDATE": "עדכן",
      "ENABLE_EMAIL_COLLECT_BOX": "אפשר תיבת איסוף דוא\"ל",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "הפעל או השבת את תיבת איסוף הדוא\"ל בשיחה חדשה",
      "AUTO_ASSIGNMENT": "אפשר הקצאה אוטומטית",
      "SENDER_NAME_SECTION": "אפשר שם סוכן בדוא\"ל",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "אפשר המשך שיחה באמצעות הדוא\"ל",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "שיחות ימשיכו באמצעות הדוא\"ל אם לאיש הקשר קיימת כתובת דוא\"ל תקנית.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "הגדרות תיבת דואר נכנס",
      "INBOX_UPDATE_SUB_TEXT": "עדכן את הגדרות תיבת הדואר הנכנס שלך",
      "AUTO_ASSIGNMENT_SUB_TEXT": "אפשר או השבת את ההקצאה האוטומטית של שיחות חדשות לסוכנים שנוספו לתיבת הדואר הנכנס הזו.",
      "HMAC_VERIFICATION": "אימות זהות משתמש",
      "HMAC_DESCRIPTION": "כדי לאמת את זהות המשתמש, תוכל להעביר `identifier_hash` עבור כל משתמש. תוכל ליצור גיבוב HMAC sha256 באמצעות ה-`identifier` עם המפתח המוצג כאן.",
      "HMAC_LINK_TO_DOCS": "תוכל לקרוא עוד כאן.",
      "HMAC_MANDATORY_VERIFICATION": "אכיפת אימות זהות משתמש",
      "HMAC_MANDATORY_DESCRIPTION": "אם מופעל, בקשות חסרות את ה-`identifier_hash` יידחו.",
      "INBOX_IDENTIFIER": "מזהה תיבת דואר נכנס",
      "INBOX_IDENTIFIER_SUB_TEXT": "השתמש ב-'inbox_identifier' המוצג כאן כדי לאמת את לקוחות ה-API שלך.",
      "FORWARD_EMAIL_TITLE": "העבר לדואר אלקטרוני",
      "FORWARD_EMAIL_SUB_TEXT": "התחל להעביר את המיילים שלך לכתובת הדוא\"ל הבאה.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "אפשר הודעות לאחר שהשיחה נפתרה",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "אפשר למשתמשי הקצה לשלוח הודעות גם לאחר פתרון השיחה.",
      "WHATSAPP_SECTION_SUBHEADER": "מפתח API זה משמש לשילוב עם ממשקי ה-API של WhatsApp.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "הזן את מפתח ה-API החדש שישמש לשילוב עם ממשקי ה-API של WhatsApp.",
      "WHATSAPP_SECTION_TITLE": "מפתח API",
      "WHATSAPP_SECTION_UPDATE_TITLE": "עדכון מפתח API",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "הזן את מפתח ה-API החדש כאן",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "עדכן",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "הרשמה משובצת של WhatsApp",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "תיבת דואר נכנס זו מחוברת באמצעות הרשמה משובצת של WhatsApp.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "תוכל להגדיר מחדש תיבת דואר נכנס זו כדי לעדכן את הגדרות WhatsApp העסקי שלך.",
      "WHATSAPP_RECONFIGURE_BUTTON": "הגדר מחדש",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "מזהה חשבון עסקי",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "מפתח API",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "התחבר ל-WhatsApp עסקי",
      "WHATSAPP_CONNECT_SUBHEADER": "שדרג להרשמה משובצת של WhatsApp לניהול קל יותר.",
      "WHATSAPP_CONNECT_DESCRIPTION": "חבר תיבת דואר נכנס זו ל-WhatsApp עסקי עבור תכונות משופרות וניהול קל יותר.",
      "WHATSAPP_CONNECT_BUTTON": "התחבר",
      "WHATSAPP_CONNECT_SUCCESS": "חובר בהצלחה ל-WhatsApp עסקי!",
      "WHATSAPP_CONNECT_ERROR": "החיבור ל-WhatsApp עסקי נכשל. אנא נסה שוב.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "WhatsApp עסקי הוגדר מחדש בהצלחה!",
      "WHATSAPP_RECONFIGURE_ERROR": "ההגדרה מחדש של WhatsApp עסקי נכשלה. אנא נסה שוב.",
      "WHATSAPP_APP_ID_MISSING": "מזהה האפליקציה של WhatsApp אינו מוגדר. אנא פנה למנהל המערכת שלך.",
      "WHATSAPP_CONFIG_ID_MISSING": "מזהה תצורת WhatsApp אינו מוגדר. אנא פנה למנהל המערכת שלך.",
      "WHATSAPP_LOGIN_CANCELLED": "הכניסה ל-WhatsApp בוטלה. אנא נסה שוב.",
      "WHATSAPP_WEBHOOK_TITLE": "אסימון אימות Webhook",
      "WHATSAPP_WEBHOOK_SUBHEADER": "אסימון זה משמש לאימות האותנטיות של נקודת הקצה של ה-Webhook.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "סנכרן תבניות",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "סנכרן תבניות הודעות מ-WhatsApp באופן ידני כדי לעדכן את התבניות הזמינות שלך.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "סנכרן תבניות",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "סנכרון התבניות הופעל בהצלחה. העדכון עשוי להימשך כמה דקות.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "סגור",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "מספר טלפון לתצוגה",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "הוסף",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "תיבת הדואר הנכנס",
          "PHONE_NUMBER": "מספר טלפון",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "חזור",
          "CANCEL": "ביטול",
          "CONTINUE": "המשך",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "עדכון הגדרות טופס טרום צ'אט"
    },
    "HELP_CENTER": {
      "LABEL": "מרכז עזרה",
      "PLACEHOLDER": "בחר מרכז עזרה",
      "SELECT_PLACEHOLDER": "בחר מרכז עזרה",
      "NONE": "כלום",
      "REMOVE": "הסר מרכז עזרה",
      "SUB_TEXT": "צרף מרכז עזרה לתיבת הדואר הנכנס"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "מגבלת הקצאה אוטומטית",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "אנא הזן ערך גדול מ-0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "הגבלת המספר המרבי של שיחות מתיבת הדואר הנכנס הזו שניתן להקצות אוטומטית לסוכן"
    },
    "ASSIGNMENT": {
      "TITLE": "שיוך שיחה",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "מחק מדיניות",
      "POLICY_LABEL": "מדיניות הקצאה",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "פעיל",
        "INACTIVE": "לא פעיל"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "נוצר מוקדם ביותר",
        "LONGEST_WAITING": "המתנה הארוכה ביותר"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin (סבב)",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "לא נמצאו מדיניות הקצאה",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "ביטול",
      "CONFIRM_DELETE": "מחק",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "הרשאה מחדש",
      "SUBTITLE": "פג תוקף החיבור שלך לפייסבוק, אנא חבר מחדש את דף הפייסבוק שלך כדי להמשיך בשירותים",
      "MESSAGE_SUCCESS": "החיבור מחדש הצליח",
      "MESSAGE_ERROR": "היתה שגיאה, בקשה נסה שוב"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "טפסי טרום צ'אט מאפשרים לך ללכוד מידע על המשתמש לפני שהם מתחילים בשיחה איתך.",
      "SET_FIELDS": "שדות טפסי טרום צ'אט",
      "SET_FIELDS_HEADER": {
        "FIELDS": "שדות",
        "LABEL": "תווית",
        "PLACE_HOLDER": "מציין מקום",
        "KEY": "מפתח",
        "TYPE": "סוג",
        "REQUIRED": "נדרש"
      },
      "ENABLE": {
        "LABEL": "אפשר טופס טרום צ'אט",
        "OPTIONS": {
          "ENABLED": "כן",
          "DISABLED": "לא"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "הודעה לפני צ'אט",
        "PLACEHOLDER": "הודעה זו תהיה גלויה למשתמשים יחד עם הטופס"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "המבקרים צריכים לספק את שמם וכתובת האימייל שלהם לפני תחילת הצ'אט"
      }
    },
    "CSAT": {
      "TITLE": "אפשר CSAT",
      "SUBTITLE": "הפעל אוטומטית סקרי CSAT בסוף השיחות כדי להבין כיצד לקוחות מרגישים לגבי חווית התמיכה שלהם. עקוב אחר מגמות שביעות רצון וזהה אזורים לשיפור לאורך זמן.",
      "DISPLAY_TYPE": {
        "LABEL": "סוג תצוגה"
      },
      "MESSAGE": {
        "LABEL": "הודעה",
        "PLACEHOLDER": "אנא הזן הודעה להצגה למשתמשים עם הטופס"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "שפה",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "חזור"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "כלל סקר",
        "DESCRIPTION_PREFIX": "שלח את הסקר אם השיחה",
        "DESCRIPTION_SUFFIX": "כל אחת מהתוויות",
        "OPERATOR": {
          "CONTAINS": "מכיל",
          "DOES_NOT_CONTAINS": "לא מכיל"
        },
        "SELECT_PLACEHOLDER": "בחר תוויות"
      },
      "NOTE": "הערה: סקרי CSAT נשלחים פעם אחת בלבד לכל שיחה",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "הגדרות CSAT עודכנו בהצלחה",
        "ERROR_MESSAGE": "לא הצלחנו לעדכן את הגדרות CSAT. אנא נסה שוב מאוחר יותר."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "הגדר את הזמינות שלך",
      "SUBTITLE": "הגדר את הזמינות שלך בווידג'ט הצ'אט החי שלך",
      "WEEKLY_TITLE": "הגדר את השעות השבועיות שלך",
      "TIMEZONE_LABEL": "בחר אזור זמן",
      "UPDATE": "עדכן את הגדרות שעות הפעילות",
      "TOGGLE_AVAILABILITY": "הפעל זמינות עסקית עבור תיבת הדואר הנכנס הזו",
      "UNAVAILABLE_MESSAGE_LABEL": "הודעה לא זמינה למבקרים",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "DAY": "יום",
        "AVAILABILITY": "זמינות",
        "HOURS": "שעות",
        "ENABLE": "אפשר זמינות ליום זה",
        "UNAVAILABLE": "אינו זמין",
        "VALIDATION_ERROR": "שעת ההתחלה צריכה להיות לפני שעת הסגירה.",
        "CHOOSE": "בחר"
      },
      "ALL_DAY": "כל היום"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "הגדר את פרטי ה-IMAP שלך",
      "NOTE_TEXT": "כדי להפעיל SMTP, אנא הגדר את IMAP.",
      "UPDATE": "עדכון הגדרות IMAP",
      "TOGGLE_AVAILABILITY": "הפעל תצורת IMAP עבור תיבת הדואר הנכנס הזו",
      "TOGGLE_HELP": "הפעלת IMAP תעזור למשתמש לקבל דוא\"ל",
      "EDIT": {
        "SUCCESS_MESSAGE": "הגדרות IMAP עודכנו בהצלחה",
        "ERROR_MESSAGE": "לא ניתן לעדכן הגדרות IMAP"
      },
      "ADDRESS": {
        "LABEL": "כתובת",
        "PLACE_HOLDER": "כתובת (לדוגמה: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "נמל",
        "PLACE_HOLDER": "נמל"
      },
      "LOGIN": {
        "LABEL": "התחבר",
        "PLACE_HOLDER": "התחבר"
      },
      "PASSWORD": {
        "LABEL": "סיסמה",
        "PLACE_HOLDER": "סיסמה"
      },
      "ENABLE_SSL": "הפעל SSL",
      "AUTH_MECHANISM": "אימות"
    },
    "MICROSOFT": {
      "TITLE": "מיקרוסופט",
      "SUBTITLE": "אשר מחדש את חשבון MICROSOFT שלך"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "הגדר את פרטי ה-SMTP שלך",
      "UPDATE": "עדכון הגדרות SMTP",
      "TOGGLE_AVAILABILITY": "הפעל תצורת SMTP עבור תיבת הדואר הנכנס הזו",
      "TOGGLE_HELP": "הפעלת SMTP תעזור למשתמש לשלוח דוא\"ל",
      "EDIT": {
        "SUCCESS_MESSAGE": "הגדרות SMTP עודכנו בהצלחה",
        "ERROR_MESSAGE": "לא ניתן לעדכן הגדרות SMTP"
      },
      "ADDRESS": {
        "LABEL": "כתובת",
        "PLACE_HOLDER": "כתובת (למשל: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "נמל",
        "PLACE_HOLDER": "נמל"
      },
      "LOGIN": {
        "LABEL": "התחבר",
        "PLACE_HOLDER": "התחבר"
      },
      "PASSWORD": {
        "LABEL": "סיסמה",
        "PLACE_HOLDER": "סיסמה"
      },
      "DOMAIN": {
        "LABEL": "דומיין",
        "PLACE_HOLDER": "דומיין"
      },
      "ENCRYPTION": "הצפנה",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "פתח את מצב אימות SSL",
      "AUTH_MECHANISM": "אימות"
    },
    "NOTE": "הערה: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "אוואטר אתר",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "האוואטר נמחק בהצלחה",
              "ERROR_MESSAGE": "היתה שגיאה, בקשה נסה שוב"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "שם האתר",
          "PLACE_HOLDER": "הזן את שם האתר שלך (למשל: Acme Inc)",
          "ERROR": "אנא הזן שם אתר חוקי"
        },
        "WELCOME_HEADING": {
          "LABEL": "כותרת ברוכים הבאים",
          "PLACE_HOLDER": "שלום שם!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "ברוך הבא לתיוג",
          "PLACE_HOLDER": "אנחנו עושים את זה פשוט להתחבר אלינו. שאל אותנו כל דבר, או שתף את המשוב שלך."
        },
        "REPLY_TIME": {
          "LABEL": "זמן תשובה",
          "IN_A_FEW_MINUTES": "בעוד כמה דקות",
          "IN_A_FEW_HOURS": "בעוד כמה שעות",
          "IN_A_DAY": "ביום"
        },
        "WIDGET_COLOR_LABEL": "צבע יישומון",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "סוג:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "דבר איתנו",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "דבר איתנו"
        },
        "UPDATE": {
          "BUTTON_TEXT": "עדכון הגדרות ווידג'ט",
          "API": {
            "SUCCESS_MESSAGE": "הגדרות ווידג'ט עודכנו בהצלחה",
            "ERROR_MESSAGE": "לא ניתן לעדכן את הגדרות הווידג'ט"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "תצוגה מקדימה",
          "SCRIPT": "תסריט"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "שמאלה",
          "RIGHT": "ימין"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "סטנדרטי",
          "EXPANDED_BUBBLE": "בועה מורחבת"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "ברירת מחדל",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "זמן מענה טיפוסי תוך כמה דקות",
        "IN_A_FEW_HOURS": "מענה ממוצע תוך כמה שעות",
        "IN_A_DAY": "מענה ממוצע לאחר יום"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "התחל שיחה",
        "CHAT_INPUT_PLACEHOLDER": "הקלד הודעה"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "אנחנו מקוונים",
          "OFFLINE": "אנחנו לא זמינים כרגע"
        },
        "USER_MESSAGE": "היי",
        "AGENT_MESSAGE": "שלום"
      },
      "BRANDING_TEXT": "מופעל על ידי Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "מיקרוסופט",
        "DESCRIPTION": "התחבר עם Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "התחבר עם Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "ספקים אחרים",
        "DESCRIPTION": "התחבר עם ספקים אחרים"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "אתר אינטרנט",
      "TWITTER_PROFILE": "טוויטר",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "אימייל",
      "TELEGRAM": "טלגרם",
      "LINE": "Line",
      "API": "ערוץ API",
      "INSTAGRAM": "אינסטגרם",
      "TIKTOK": "TikTok",
      "VOICE": "קול"
    }
  }
}
